require('./mortgageRequestWorkData.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const { cloneDeep, get, isEmpty, first, contains, find } = require('lodash');

// @ utilities
const { recordProcess, PROC_START, PROC_CANCEL } = require('utilities/tagging');
const { getMultiples, getTexts, getTextDescription, getTextLinkDescription } = require('utilities/dragNDropUpload');
const { scrollToTop } = require('commonsUtilities/scrollUtils');

// @ track processes
const { PROC_CHANGE_WORK_DATA } = require('constants/mortgageRequestProcesses');

// @ commons
const { formatText, getLanguage } = require('core/i18n').i18n;

// @ components
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { DragNDropUpload } = require('commonsComponents/dragNDropUpload');
const { LoadingSection } = require('commonsComponents/loadingSection');
const MortgageRequestGoToDocCenter = require('../mortgageRequestGoToDocCenter/mortgageRequestGoToDocCenter');
const { MortgageRequestManagerDocumentation } = require('components/mortgageRequest/mortgageRequestPanel/mortgageRequestManagerDocumentation/mortgageRequestManagerDocumentation');

const CurrentInfo = require('./currentInfo');
const CeaCode = require('./ceaCode');

// @ actions
const mortgageRequestWorkDataActions = require('actions/mortgageRequest/mortgageRequestWorkData');
const dataProprietorActions = require('actions/mortgageRequest/mortgageRequestDataProprietor');
const documentActions = require('actions/mortgageRequest/mortgageRequestDocumentationCenter');

// @ constants
const { HIDE_INDIVIDUAL_UPLOAD_DOCUMENTS_HOLDER } = require('constants/flagBasedFeatures');
const mortgageRequestPanelStates = require('constants/mortgageRequestPanelStates');
const { SEDE_ELECTRONICA_SEGURIDAD_SOCIAL_SPANISH, SEDE_ELECTRONICA_SEGURIDAD_SOCIAL_ENGLISH } = require('constants/links');
const { NOM, VL, NOM_VL } = require('constants/mortgageRequestDocumentsTypes');
const { DOCUMENTS_STATUS, EMPLOYMENT_SITUATION, EMPTY_SELECTOR_FIELD } = require('constants/mortgageRequestHolderData');
const {
    DRAG_N_DROP_UPLOAD_AMOUNT_FILES_LIMIT,
    DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE,
    DRAG_N_DROP_UPLOAD_MAX_LENGTH_FILE_NAME,
    DRAG_N_DROP_UPLOAD_MAX_SIZE,
    DRAG_N_DROP_UPLOAD_VALID_TYPES_FILES,
    DRAG_N_DROP_UPLOAD_TITLE,
    DRAG_N_DROP_UPLOAD_FILE_TEXT
} = require('constants/commonsComponents');
const { initialValues } = require('./initialValues');
const BASE_YEAR = 1900;
const ACTUAL_YEAR = new Date().getFullYear();
const ACTUAL_MONTH = new Date().getMonth() + 1

class MortgageRequestWorkData extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isDisabledButton: true
        }

        this.values = cloneDeep(initialValues);

        this.disableCeaCode = false;
        this.isMufaceSelected = false;
        this.workDataInfoChecked = false;

        this.readyForSubmit = {
            currentInfo: false,
            ceaCode: false
        };
        this.child = {
            ceaCodeComponent: {}
        };
        this.file = {};
        this.files = [];
        this.errorUploadFile = '';

        this.handleOnChangeFile = this.handleOnChangeFile.bind(this);
        this.handleOnDownloadFile = this.handleOnDownloadFile.bind(this);
        this.handleOnSave = this.handleOnSave.bind(this);
        this.handleMufaceOption = this.handleMufaceOption.bind(this);
        this.handleCancelEditWorkData = this.handleCancelEditWorkData.bind(this);
    }

    componentDidMount() {
        recordProcess(PROC_CHANGE_WORK_DATA, PROC_START);
        const { holderNumber, getHolderData, summaryDocsState, requestWorkFlag } = this.props;
        requestWorkFlag(false);
        getHolderData(holderNumber);

        if (!summaryDocsState.get('documentsRequested')) {
            const { requestSummaryDocumentation } = this.props;
            requestSummaryDocumentation();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.workDataState !== prevProps.workDataState) {
            const { flag } = this.props.workDataState.toJS();
            const { flag: flagPre } = prevProps.workDataState.toJS();

            if ((flag !== flagPre) && (flag === true)) {
                this.checkWorkDataInfo();
                this.forceUpdate();
            }
        }
    }

    componentWillUnmount() {
        this.props.resetState();
    }

    getHolderDocumentData() {
        const { holderNumber, dataProprietorState } = this.props;

        const dataPropietorInfo = dataProprietorState.get('data').toJS().filter(holder => {
            return holder.numeroTitular === holderNumber;
        });

        return get(dataPropietorInfo[0], 'datosPersonales.documentoDeIdentidad', {});
    }

    checkFile() {
        const { summaryDocsState } = this.props;
        const proprietor = this.getHolderDocumentData();
        const docsSummary = summaryDocsState.get('data').toJS();
        const isMufaceSelected = this.values.currentInfo.jobSituation === EMPLOYMENT_SITUATION.FUNCIONARIO_MUFACE;
        const fileOptionList = [NOM, VL, NOM_VL];

        if (isMufaceSelected) {
            this.disableCeaCode = true;
        }

        this.files = docsSummary.filter(doc => {
            const documentDataStatus = get(doc, 'estado', DOCUMENTS_STATUS.NONE) || DOCUMENTS_STATUS.NONE;

            const isHolderDoc = (
                doc.tipoDocumento === proprietor.tipoDocumentoIdentidad &&
                doc.numeroDocumento === proprietor.identificador
            );
            const isWorkDoc = find(fileOptionList, (op) => { return op === doc.tipoDocumentoId });
            const isDocStateOk = (
                documentDataStatus !== DOCUMENTS_STATUS.PEND_APORTAR &&
                documentDataStatus !== DOCUMENTS_STATUS.NONE
            );

            return isHolderDoc && isWorkDoc && isDocStateOk;
        });

        this.disableCeaCode = this.files.length > 0 ? true : false;
    }

    checkWorkDataInfo() {
        const workDataState = this.props.workDataState.toJS();

        const monthIncorporationDate = !workDataState.mesIncorporacionTrabajo ||
            workDataState.mesIncorporacionTrabajo.length > 1 ?
            workDataState.mesIncorporacionTrabajo :
            '0' + workDataState.mesIncorporacionTrabajo;

        const newValues = {
            currentInfo: {
                jobSituation: workDataState.situacionLaboral,
                contractType: workDataState.tipoContratoTrabajo,
                jobIncorporationDate: {
                    month: monthIncorporationDate,
                    year: workDataState.anioIncorporacionTrabajo
                },
                studyLevel: workDataState.nivelEstudios
            },
            ceaCode: {
                idCea: workDataState.idCea,
                dateGenCea: {
                    day: workDataState.fechaGenCea[0],
                    month: workDataState.fechaGenCea[1],
                    year: workDataState.fechaGenCea[2]
                },
                inputsCode: {
                    1: workDataState.codigoCea1,
                    2: workDataState.codigoCea2,
                    3: workDataState.codigoCea3,
                    4: workDataState.codigoCea4,
                    5: workDataState.codigoCea5,
                    6: workDataState.codigoCea6
                }
            }
        };

        this.values = newValues;

        this.checkFile();

        this.workDataInfoChecked = true;

        this.forceUpdate();
    }

    handleCancelEditWorkData(evt) {
        evt.preventDefault();
        recordProcess(PROC_CHANGE_WORK_DATA, PROC_CANCEL);
        this.props.history.push('/myprofile/mortgage/panel');
    }

    setDisableButton() {
        const TRABAJADOR_CUENTA_AJENA = 'TRABAJADOR_CUENTA_AJENA';
        const FUNCIONARIO_MUFACE = 'FUNCIONARIO_MUFACE';
        const FUNCIONARIO_SEG_SOCIAL = 'FUNCIONARIO_SEG_SOCIAL';

        const {
            jobSituation,
            contractType,
            studyLevel,
            jobIncorporationDate
        } = this.values.currentInfo;

        const getValidMonth = () => {
            let month = '';
            let incomingMonth = jobIncorporationDate.month;
            let incomingYear = jobIncorporationDate.year;

            if(parseInt(incomingYear) === ACTUAL_YEAR) {
                if(incomingMonth <= ACTUAL_MONTH) {
                    month = incomingMonth;
                }
            } else {
                month = incomingMonth;
            }

            return month > 0 ? month : '';
        };

        const getValidYear = () => {
            let incomingYear = jobIncorporationDate.year;
            return incomingYear > BASE_YEAR && incomingYear.length === 4 ? incomingYear : '';
        };

        const fieldsValues = [contractType, studyLevel, getValidMonth(), getValidYear()];
        let isDisabledButton = false;

        if(
            jobSituation === TRABAJADOR_CUENTA_AJENA ||
            jobSituation === FUNCIONARIO_MUFACE ||
            jobSituation === FUNCIONARIO_SEG_SOCIAL
        ) {
            isDisabledButton = fieldsValues.some(item => item === '');
        }

        if(jobSituation === EMPTY_SELECTOR_FIELD){
            isDisabledButton = true
        }

        this.setState({isDisabledButton});
    }

    handleMufaceOption(isMufaceSelected) {
        this.setDisableButton();

        if ((isMufaceSelected && !this.disableCeaCode) || (!isMufaceSelected && this.disableCeaCode)) {
            if (!!this.child.ceaCodeComponent.updateValues) {
                this.child.ceaCodeComponent.updateValues(cloneDeep(initialValues.ceaCode));
            }
            this.isMufaceSelected = isMufaceSelected;
            if (!isEmpty(this.file) || this.files.length) {
                this.disableCeaCode = true;
            } else {
                this.disableCeaCode = isMufaceSelected;
            }
            this.forceUpdate();
            return true;
        }
        return false;
    }

    handleOnChangeFile(file) {
        if (file && !file.error) {
            this.file = file.file;
            this.disableCeaCode = !!this.file;
            this.child.ceaCodeComponent.updateValues(cloneDeep(initialValues.ceaCode));
            this.forceUpdate();
        }
    }

    handleOnDownloadFile() {
        const { requestDocuments } = this.props;

        const file = first(this.files);
        const proprietor = this.getHolderDocumentData();

        requestDocuments({
            documentType: file.tipoDocumentoId,
            idDocumentType: proprietor.tipoDocumentoIdentidad,
            idDocumentNumber: proprietor.identificador
        });
    }

    handleOnSave() {
        let ok = true;
        let file = null;
        this.errorUploadFile = '';
        const validateFileOk = !isEmpty(this.file) || !!this.files.length;
        const inputErrorText = formatText('common-requiredField');
        const { immFlagBasedFeatures } = this.props;
        const ffHideUpload = !(immFlagBasedFeatures.get(HIDE_INDIVIDUAL_UPLOAD_DOCUMENTS_HOLDER))

        const currentoInfoValues = this.child.currentInfoComponent.validateInputsData();
        // validar que currentInfo Esté Ok. Si hay error mostrar campos malos
        if (!currentoInfoValues) {
            ok = false;
            scrollToTop();
        } else {
            this.values.currentInfo = currentoInfoValues;
        }

        if (!this.disableCeaCode) {
            const ceaCodeValues = ffHideUpload
                ? this.child.ceaCodeComponent.validateInputsData()
                : cloneDeep(initialValues.ceaCode)

            if (!ceaCodeValues) {
                ok = false;
            } else {
                this.values.ceaCode = ceaCodeValues;
            }
        } else {
            this.values.ceaCode = cloneDeep(initialValues.ceaCode);

            if (!validateFileOk) {
                ok = false;
                this.errorUploadFile = inputErrorText;
            } else {
                file = this.file;
            }
        }

        ok && this.props.updateWorkData(this.props.holderNumber, this.values, file, this.props.history) || this.forceUpdate();
    }

    buildCEA() {
        return (
            <ContentBox customClassName="separator">
                <h2>{formatText('mortgageRequestWorkData-workCEAInfoTitle')}</h2>
                <div className="cea-info"></div>
                <p>{formatText('mortgageRequestWorkData-workCEAInfoDescription')}</p>
            </ContentBox>
        )
    }

    buildManagerDocumentation() {
        const { holdersDataValidation, holderNumber } = this.props;
        const holderKey = holderNumber === 2 ? 'isCoHolder' : 'isHolder';
        const isCompleted = holdersDataValidation.getIn([holderKey, 'isCompleted']);
        return isCompleted && (
            <MortgageRequestManagerDocumentation />
        )
    }

    render() {
        const { workDataState, mortgageRequestState, docCenterState, immFlagBasedFeatures, dataProprietors } = this.props;
        const inputErrorText = formatText('common-requiredField');
        const mufaceText = formatText('mortgageRequestWorkData-paysheet');
        const noMufaceText = formatText('mortgageRequestWorkData-worklife');
        const mufaceOptionText = this.isMufaceSelected ? mufaceText : noMufaceText;
        const currentState = mortgageRequestState.get('estado');
        const isApprovedDataProprietor = contains(mortgageRequestPanelStates.APPROVED_STATES_DATA_PROPRIETOR, currentState);
        const sedeElectronicaSeguridadSocialLink = getLanguage() === 'en' ? SEDE_ELECTRONICA_SEGURIDAD_SOCIAL_ENGLISH
            : SEDE_ELECTRONICA_SEGURIDAD_SOCIAL_SPANISH;

        const isFetching = workDataState.get('isFetching') || workDataState.get('isFetchingFile');
        const file = first(this.files) || false;
        const isFetchingFile = file ? docCenterState.getIn(['isFetching', file.tipoDocumentoId]) : false;
        const multiples = getMultiples(DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE);
        const texts = getTexts(DRAG_N_DROP_UPLOAD_AMOUNT_FILES_LIMIT, DRAG_N_DROP_UPLOAD_MAX_LENGTH_FILE_NAME, DRAG_N_DROP_UPLOAD_MAX_SIZE, multiples, DRAG_N_DROP_UPLOAD_VALID_TYPES_FILES);
        const textDescription = getTextDescription(DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE);
        const textLinkDescription = getTextLinkDescription(DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE);
        const ffHideUpload = !(immFlagBasedFeatures.get(HIDE_INDIVIDUAL_UPLOAD_DOCUMENTS_HOLDER))
        const showCEA = ffHideUpload ? this.buildCEA() : null;
        const {isDisabledButton} = this.state;
        const personalData = dataProprietors.get('personalData');
        const hasOperationProcessId = personalData.some(person => person?.operationProcessId);

        if (this.workDataInfoChecked) {
            return (
                <div className="row no-outside-gutter">
                    <div className="col-md-8">
                        <ContentBox>
                            <OKBoxTitle
                                value={formatText('mortgageRequestWorkData-subtitle')}
                                size="medium"
                            />
                            <CurrentInfo
                                ref={component => this.child.currentInfoComponent = component}
                                inputErrorText={inputErrorText}
                                onHandleMufaceOption={this.handleMufaceOption}
                                values={this.values['currentInfo']}
                                disable={isApprovedDataProprietor || hasOperationProcessId }
                            />


                            {ffHideUpload &&
                                <div className="uploadFile">
                                    <hr />

                                    <div>
                                        <div className="sm-title">
                                            {formatText('mortgageRequestWorkData-workLifeTitleNow')}
                                            <span> {formatText('mortgageRequestWorkData-workLifeTitleStrongText', [mufaceOptionText])}</span>
                                            {formatText('mortgageRequestWorkData-workLifeTitleRemainingText')}
                                        </div>

                                        <h6 className="inner">{formatText('mortgageRequestWorkData-workLifeInnerTitle', [mufaceOptionText])}</h6>

                                        <p>{formatText('mortgageRequestWorkData-workLifeDescription', [mufaceOptionText])}</p>

                                        <DragNDropUpload
                                            idName="vidaLaboral"
                                            onChange={this.handleOnChangeFile}
                                            ammountFiles={this.files.length}
                                            error={!!this.errorUploadFile}
                                            errorMessage={this.errorUploadFile}
                                            overwriteFile={true}
                                            disabled={isApprovedDataProprietor}
                                            loading={isFetching || isFetchingFile}
                                            onDownload={this.handleOnDownloadFile}
                                            texts={texts}
                                            title={DRAG_N_DROP_UPLOAD_TITLE}
                                            textDescription={textDescription}
                                            textLinkDescription={textLinkDescription}
                                            fileText={DRAG_N_DROP_UPLOAD_FILE_TEXT}
                                        />
                                    </div>
                                    <MortgageRequestGoToDocCenter />

                                    <hr />

                                    <CeaCode
                                        ref={component => this.child.ceaCodeComponent = component}
                                        inputErrorText={inputErrorText}
                                        disable={this.disableCeaCode || isApprovedDataProprietor}
                                        values={this.values['ceaCode']}
                                    />
                                </div>
                            }

                            <hr />

                            <div className="row">
                                <div className="col-xs-9 mortgage-request-job-data-view__margin-button">
                                    <a
                                        href="#"
                                        className="ok-link"
                                        onClick={this.handleCancelEditWorkData}
                                    >
                                        {formatText('mortgageRequestHolderInformation-returnLink')}
                                    </a>
                                </div>
                                <div className="col-xs-3">
                                    <div className="mortgage-request-holder-information__right-content">
                                        {   
                                            !hasOperationProcessId && (
                                                <OKButton
                                                    loading={isFetching}
                                                    disabled={isDisabledButton || isFetching || isApprovedDataProprietor}
                                                    onClick={this.handleOnSave}
                                                    modifier="primary"
                                                    children={formatText('mortgageRequestHolderInformation-saveButton')}
                                                />
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </ContentBox>

                    </div>

                    <div className="mortgage-request-job-data-view__info col-md-4">
                        {this.buildManagerDocumentation()}
                        <ContentBox>
                            <h2>{formatText('mortgageRequestWorkData-workLifeInfoTitle')}</h2>
                            <p>{formatText('mortgageRequestWorkData-workLifeInfoDescription')}</p>
                            <OKLink
                                modifier="editorial"
                                target="_blank"
                                id="btnSedeSeguridadSocial"
                                to={sedeElectronicaSeguridadSocialLink}
                                children={formatText('mortgageRequestWorkData-workLifeInfoLink')}
                            />
                        </ContentBox>
                        {showCEA}
                    </div>
                </div>
            );
        } else {
            return <LoadingSection />
        }
    }
}

MortgageRequestWorkData.propTypes = {
    holderNumber: PropTypes.number,
    workDataState: PropTypes.object,
    mortgageRequestState: PropTypes.object,
    dataProprietorState: PropTypes.object,
    summaryDocsState: PropTypes.object,
    docCenterState: PropTypes.object,
    getHolderData: PropTypes.func,
    resetState: PropTypes.func,
    requestWorkFlag: PropTypes.func,
    updateWorkData: PropTypes.func,
    requestSummaryDocumentation: PropTypes.func,
    requestDocuments: PropTypes.func,
    immFlagBasedFeatures: PropTypes.object,
    history: PropTypes.object.isRequired,
    holdersDataValidation: PropTypes.object,
}

module.exports.constructor = MortgageRequestWorkData;

module.exports.MortgageRequestWorkData = connect(
    state => ({
        workDataState: state.mortgageRequestWorkData,
        mortgageRequestState: state.mortgageRequestState,
        dataProprietorState: state.mortgageRequestDataProprietor,
        summaryDocsState: state.mortgageRequestSummaryDocumentation,
        docCenterState: state.mortgageRequestDocumentationCenter,
        immFlagBasedFeatures: state.flagBasedFeatures,
        holdersDataValidation: state.mortgageHoldersDataValidation,
        dataProprietors: state.mortgageRequestDataProprietor,
    }), {
        getHolderData: mortgageRequestWorkDataActions.getHolderData,
        resetState: mortgageRequestWorkDataActions.reset,
        requestWorkFlag: mortgageRequestWorkDataActions.requestWorkFlag,
        updateWorkData: mortgageRequestWorkDataActions.updateWorkData,
        requestSummaryDocumentation: dataProprietorActions.requestSummaryDocumentation,
        requestDocuments: documentActions.getDocument,
        requestDataProprietor: dataProprietorActions.requestDataProprietor,
    })(withRouter(MortgageRequestWorkData));
